import NavTabs, { Tab } from './NavTabs'

export { NavTabs, Tab }
